module.exports = __webpack_public_path__ + "static/img/defultTitle.d950848.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/defultTitle.png
// module id = 4fNK
// module chunks = 1